/*
 * Ryan O'Dowd
 * 2024-08-19
 * © Copyright 2024 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
// @TODO: import 'react-multi-email/style.css';
import Button from '@components/common/Button';
import Checkbox from '@components/common/Checkbox';
import Dialog from '@components/common/Dialog';
import IconButton from '@components/common/IconButton';
import React, {
  // @TODO: useState,
} from 'react';
/* @TODO:
import {
  ReactMultiEmail,
} from 'react-multi-email';
import isEmail from 'validator/lib/isEmail';
*/
import Text from '@components/common/Text';
// @TODO: import TextInput from '@components/common/TextInput';
// @TODO: import Tooltip from '@components/common/Tooltip';
import {
  View,
} from 'react-native';
import {
  apiUpdateClassroom,
  // @TODO: inviteStudents,
} from '@utils/store/actions';
import getStyles from './styles';
import hooks from '@hooks';

const InviteDialog = (props: InviteDialogProps) => {
  const styles = hooks.useStyles(getStyles);
  const i18n = hooks.useI18n();
  const dispatch = hooks.useTypedDispatch();

  const _isAdvancedInviteOpen = false; // @TODO:  const [_isAdvancedInviteOpen, setIsAdvancedInviteOpen] = useState(false);
  // @TODO: const [_studentInivitationNamesAndEmails, setStudentInivitationNamesAndEmails] = useState([]);

  const classroom = hooks.useTypedSelector((state) => state.classrooms[props.classroomId] || {}); // @TODO: shouldn't need `{}`

  // @TODO: const classroomStudents = hooks.useTypedSelector((state) => state.classroomStudents[props.classroomId] || []).filter((student) => ['active', 'invited'].includes(student.status), (oldValue, newValue) => JSON.stringify(oldValue) === JSON.stringify(newValue)); // @TODO: shouldn't need `[]`

  /* @TODO:
  const _getLabel = (email, index, removeEmail) => { // @TODO: need this?
    let style = styles.newEmail;
    let tooltipText = '';
    if (classroomStudents.filter((p) => !p.user_id).map((p) => `${p.invitation_name} <${p.invitation_email}`).includes(email)) { // @TODO: implement this
      style = styles.alreadyInvitedEmail;
      tooltipText = 'An invitation has already been sent to this email address, so a reminder will be sent instead.';
    } else if (classroomStudents.filter((p) => p.user_id).map((p) => p.invitation_email).includes(email)) { // @TODO: implement this
      style = styles.alreadyAcceptedEmail;
      tooltipText = 'An invitation has already been accepted by this email address, so it will be skipped.';
    }
    return (
      <Tooltip key={`${index}-${email}`} title={tooltipText}>
        <View data-tag key={`${index}-${email}`} style={[styles.legendText, styles.emailInputText, style]}>
          {email}
          <View data-tag-handle onClick={() => removeEmail(index)}>{/* @TODO: better styling here /}
            ×
          </View>
        </View>
      </Tooltip>
    );
  };
  */

  return (
    <Dialog
      visible={props.isOpen}
      onDismiss={props.onClose}
    >
      <Dialog.Title>
        Invite students
        {/* @TODO: shouldn't be an option right now
        <View style={styles.titleAndAction}>
          <Button
            mode='outlined'
            onPress={() => setIsAdvancedInviteOpen((curr) => !curr)}
          >
            {_isAdvancedInviteOpen ? 'Invite with link' : 'Advanced invitations'}
          </Button>
        </View>
        */}
      </Dialog.Title>
      <Dialog.Content>
        {!_isAdvancedInviteOpen &&
          <View>
            {/* @TODO:
            <Text>{'Inviting students with a public join code is the easiest way to get started.  Students can enter the classroom code in their accounts to join (side menu -> Groups).  For finer control of join codes, please select "advanced invitations".'}</Text>
            */}
            <Text>{'Inviting students with a public join code is the easiest way to get started.  Students can enter the classroom code in their accounts to join (side menu -> Groups).'}</Text>
            <View style={styles.joinCodeContainer}>
              <Checkbox
                isChecked={!!classroom.is_join_code_enabled}
                onPress={() => dispatch(apiUpdateClassroom(props.classroomId, {isJoinCodeEnabled: +(!classroom.is_join_code_enabled)}, null))} // @TODO: might require page refresh since classroom update doesn't update redux right now (expecting school to be updated, not classroom)
                label='Invite students to join via public join code:'
              />
              <View style={[styles.joinCodeWrapper, !classroom.is_join_code_enabled && styles.disabled]}>
                <code style={{...styles.joinCode, ...(!classroom.is_join_code_enabled ? styles.disabled : {})}}>{classroom.join_code}</code>{/* @TODO: can make code a prop on Text */}
                <IconButton
                  disabled={!classroom.is_join_code_enabled}
                  icon='content-copy'
                  iconColor={styles.colors.gray}
                  onPress={(__event) => {
                    navigator.clipboard.writeText(classroom.join_code);
                  }}
                />
              </View>
            </View>
          </View>
        }

        {/* @TODO:
        {_isAdvancedInviteOpen &&
          <View>
            <Text>{'Students can be invited manually with their own unique join codes.  This is helpful for smaller classrooms or to ensure that only invited students can join.  For bulk invitations, you can click on the "invite with link" button.'}</Text>
            <Text>Please enter the names of the students you would like to invite.  Names must be entered in the format <code style={styles.code}>FirstName LastName</code>. Multiple students should be separated by a comma (<code style={styles.code}>,</code>) or semicolon (<code style={styles.code}>;</code>).</Text>
            {/ @TODO: show email preview /}
            {/ @TODO: optional personal note that teacher can attach /}
            {/ @TODO:
            <ReactMultiEmail// @TODO: input field is ugly
              style={styles.emails}
              // @TODO: placeholder='email-address-1;email-address-2'
              emails={_studentInivitationNamesAndEmails} // @TODO: does this need to be an array? currently a string
              onChange={(emails) => setStudentInivitationNamesAndEmails(emails)}
              validateEmail={(email) => {
                return isEmail(email);
              }}
              getLabel={_getLabel}
            />
            <Text style={styles.legend}>Invitations will be sent to all <View style={[styles.legendText, styles.newEmail]}>new addresses</View>, reminders will be sent to <View style={[styles.legendText, styles.alreadyInvitedEmail]}>existing addresses</View>, and <View style={[styles.legendText, styles.alreadyAcceptedEmail]}>accepted invitations</View> will be skipped.</Text>{/* @TODO: only show legend if some are yellow or red (and even then, only show if present) /}
            /}
            <TextInput
              value={_studentInivitationNamesAndEmails}
              onChangeText={(text: any) => setStudentInivitationNamesAndEmails(text)}
              multiline={true}
              // @TODO: paper equivalent? minRows={1}
              // @TODO: paper equivalent? maxRows={6}
              placeholder='John Doe, Jane Smith, etc.'
              label='Student names'
            />
          </View>
        }
        */}
      </Dialog.Content>
      <Dialog.Actions>
        <Button
          mode={_isAdvancedInviteOpen ? 'text' : 'contained'}
          onPress={props.onClose}
        >
          {_isAdvancedInviteOpen ? i18n('cancel') : i18n('close')}
        </Button>

        {/* @TODO:
        {_isAdvancedInviteOpen &&
          <Button
            disabled={!_studentInivitationNamesAndEmails.length}
            onPress={() => {
              / @TODO:
              const studentEmails = _studentInivitationNamesAndEmails.split(/[\s,;]+/).map((s) => s.trim()).filter((s) => s.length && isEmail(s));
              if (studentEmails.length !== (_studentInivitationNamesAndEmails.match(/@/g) || []).length) {
                // @TODO: warn teacher that there are invalid emails
                return;
              }
              /
              const studentNames = _studentInivitationNamesAndEmails.split(/[,;]/g).map((s) => s.trim()).filter((s) => s.length);
              dispatch(inviteStudents(props.classroomId, studentNames)); // @TODO: or by email
              props.onClose();
              // @TODO: clear text input
            }}
          >
            Add students
          </Button>
        }
        */}
      </Dialog.Actions>
    </Dialog>
  );
};

class InviteDialogProps {
  schoolId: number;
  classroomId: number;
  isOpen: boolean;
  onClose: () => void;
};

export default InviteDialog;
